// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Popover from "@material-ui/core/Popover";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Badge from "@material-ui/core/Badge";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../../global/types/GeneralTypes";
import DisplayFace from "./DisplayFace";

const styles = (theme: DictionaryType): DictionaryType => ({
  enrolItem: {
    "&:hover": {
      "& $badgeContent": {
        opacity: 0
      }
    }
  },
  badgeContent: {},
  badgeRoot: {
    width: "96px",
    height: "96px",
    margin: "0 15px 15px 0",
    float: "left"
  },
  cardImage: {
    width: "375px",
    height: "375px"
  }
});

type EnrolmentItemStatesType = {
  anchorEl: EventTarget | null
};

type EnrolmentItemClassesType = {
  enrolItem: DictionaryType,
  badgeContent: DictionaryType,
  badgeRoot: DictionaryType,
  cardImage: DictionaryType
};

type EnrolmentItemPropsType = {
  classes: EnrolmentItemClassesType,
  imgUrl: string,
  deletePhoto?: Function,
  faces?: Array<*>,
  badge?: number
};

class EnrolmentItem extends Component<
  EnrolmentItemPropsType,
  EnrolmentItemStatesType
> {
  constructor(props: EnrolmentItemPropsType) {
    super(props);
    this.state = {
      anchorEl: null
    };
  }

  imageSelect = (e: Event) => {
    this.setState({ anchorEl: e.target });
  };

  imageUnselect = () => {
    this.setState({ anchorEl: null });
  };

  render(): * {
    const classes = this.props.classes;
    const anchorEl = this.state.anchorEl;
    const open = !!anchorEl;
    const imgUrl = this.props.imgUrl;

    return (
      <div className={classes.enrolItem}>
        {this.props.badge ? (
          <Badge
            badgeContent={this.props.badge}
            color="primary"
            classes={{
              root: classes.badgeRoot,
              badge: this.props.deletePhoto && classes.badgeContent
            }}
          >
            <DisplayFace
              img={imgUrl}
              isZoomin
              onClick={(e: Event): * => this.imageSelect(e)}
              {...(this.props.deletePhoto
                ? { cancelClick: this.props.deletePhoto }
                : {})}
            />
          </Badge>
        ) : (
          <DisplayFace
            img={imgUrl}
            isThumbNail
            isZoomin
            onClick={(e: Event): * => this.imageSelect(e)}
            {...(this.props.deletePhoto
              ? { cancelClick: this.props.deletePhoto }
              : {})}
          />
        )}
        <Popover
          open={open}
          anchorEl={anchorEl}
          anchorReference="anchorEl"
          anchorOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
          onClose={this.imageUnselect}
        >
          <Card>
            <CardContent>
              {this.props.faces ? (
                this.props.faces.map((face: *, i: number): * => (
                  <img
                    key={i}
                    src={face.imgUrl}
                    className={classes.cardImage}
                  />
                ))
              ) : (
                <img src={imgUrl} className={classes.cardImage} />
              )}
            </CardContent>
          </Card>
        </Popover>
      </div>
    );
  }
}

export default withStyles(styles)(EnrolmentItem);
